import React, { useEffect } from "react";
import PendingSupplierRequests from "AppSrc/project/details/supplierRequest";
import { useFullIds } from "storybook-dashboard/utils/hooks";
import { Spinner } from "traec-react/utils/entities";
import { ErrorBoundary } from "storybook-dashboard/errors";
import useApi from "storybook-dashboard/utils/fetching";
import { ProjectPermission } from "../utils/permissions";
import { TabWrapper, TabPanel, defaultTabStyles } from "../../components/TabComponents";
import MemberList from "./memberList";
import InviteList from "./inviteList";
import DisciplineList from "./disciplineList";
import AuthGroupList from "./authGroupList";
import useToken from "storybook-dashboard/auth/token";
import { Hide } from "storybook-dashboard/utils";

export function ProjectMembers({ projectId }) {
  // const context = useProjectContext();

  const { getClaims } = useToken();
  const claims = getClaims();
  const isSuperUser = claims?.get("is_superuser") || claims?.get("is_tenant_superuser") || false;

  return (
    <div className="container-fluid">
      {/* Tabbed interface for project member management */}
      <TabWrapper
        defaultTab="members"
        navId="projectMembersTabs"
        contentId="projectMembersTabContent"
        customStyles={defaultTabStyles}
      >
        {/* Members Tab */}
        <ErrorBoundary>
          <TabPanel tabId="members" label="Users">
            <MemberList projectId={projectId} />
          </TabPanel>
        </ErrorBoundary>

        {/* Invites Tab */}
        <ErrorBoundary>
          <TabPanel tabId="invites" label="Pending User Invites">
            <InviteList projectId={projectId} />
          </TabPanel>
        </ErrorBoundary>

        {/* Disciplines Tab */}
        <ErrorBoundary>
          <TabPanel tabId="disciplines" label="User Roles">
            <DisciplineList projectId={projectId} />
          </TabPanel>
        </ErrorBoundary>

        {/* Auth Groups Tab - Protected by permission */}
        <ErrorBoundary>
          <Hide when={!isSuperUser}>
            <TabPanel tabId="authGroups" label="User Permissions">
              <AuthGroupList projectId={projectId} />
            </TabPanel>
          </Hide>
        </ErrorBoundary>
      </TabWrapper>
    </div>
  );
}

export default function ProjectMemberPage(props) {
  let { projectId } = useFullIds();
  let { data: project, isLoading } = useApi("/api/project/{projectId}/", { projectId });

  if (isLoading || !project) return <Spinner />;

  return (
    <React.Fragment>
      <ProjectMembers projectId={projectId} />
      <PendingSupplierRequests project={project} />
    </React.Fragment>
  );
}
